import { Estimate, EstimateItem } from 'src/api';
import { currency } from 'src/util/formatters';

export function hasMemberSavings(estimate: Estimate | EstimateItem): boolean {
    return (estimate.memberSavingsMin ?? 0) !== 0 || (estimate.memberSavingsMax ?? 0) !== 0;
}

export function hasMemberSavingsRange(estimate: Estimate): boolean {
    return estimate.memberSavingsMin !== estimate.memberSavingsMax;
}

/**
 * Shows the currency of member savings (for members) or member price (range) (for non-members).
 * @param estimate The estimate or estimate item.
 * @param isMember Only required for estimate item.
 */
export function memberSavings(
    estimate: Estimate | EstimateItem,
    isMember?: boolean,
    positiveSavings?: boolean
): string | null {
    if (!hasMemberSavings(estimate)) {
        return null;
    }

    const addend = isEstimate(estimate)
        ? (typeof isMember === 'boolean' ? isMember : estimate.isMember)
            ? 0
            : estimate.total
        : isMember
        ? 0
        : estimate.standardPrice;
    const multiplier = positiveSavings ? -1 : 1;

    const memberSavingsMin = estimate.memberSavingsMin || 0;
    const memberSavingsMax = estimate.memberSavingsMax || 0;

    const min = currency(addend ? addend + memberSavingsMin : memberSavingsMin * multiplier);

    if (
        estimate.memberSavingsMax !== 0 &&
        estimate.memberSavingsMax !== estimate.memberSavingsMin
    ) {
        const max = currency(addend ? addend + memberSavingsMax : memberSavingsMax * multiplier);
        return `${min} – ${max}`;
    }

    return min;
}

function isEstimate(estimate: Estimate | EstimateItem): estimate is Estimate {
    return typeof (estimate as Estimate).isMember === 'boolean';
}
